import React from 'react'
import { TidewaysContext } from '../app/context'
import Navigator from '../app/navigator'
import { ActiveSlot } from '../domain/ActiveSlot'
import { GraphEntity } from '../domain/GraphEntity'
import Tooltip from '../monitor/graph/tooltip'
import { GraphComponent } from './graph'

interface Props {
    navigator: Navigator
    parameters: { [key: string]: string }
    tidewaysContext: TidewaysContext
    loading: boolean
    data: GraphEntity
    dataFixedTimezone: string
    moveUpTooltip?: number
}
interface State {
    activeSlot: ActiveSlot
}
export class TooltipGraphComponent extends React.Component<Props, State> {
    public static displayName = 'Graph'

    public static defaultProps = {
        loading: false,
        data: null,
    }

    public state: State = {
        activeSlot: {
            timeIndex: null,
            mouse: null,
        },
    }

    public changeActiveSlot = activeSlot => this.setState({ activeSlot })

    public render() {
        let hasDownstream = false
        if (this.props.data && this.props.data.report) {
            hasDownstream = this.props.data.report.hasDownstream
        }

        return (
            <React.Fragment>
                <GraphComponent {...this.props} changeActiveSlot={this.changeActiveSlot} />
                <Tooltip
                    data={this.props.data}
                    activeSlot={this.state.activeSlot}
                    percentileLabel="95% Percentile"
                    downstreamEnabled={hasDownstream}
                    showAverages
                    parentSelector=".history-box"
                    moveUp={this.props.moveUpTooltip}
                    dataFixedTimezone={this.props.dataFixedTimezone}
                    showMemory
                />
            </React.Fragment>
        )
    }
}
